angular.module('routes.simulation.states.SimulationStatesController', [
  'stack'
])

/**
 * The SimulationStatesController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class SimulationStatesController
 * @constructor
 * @module routes.simulation.states.SimulationStatesController
 **/
.controller('SimulationStatesController', [
  '$scope',
  '$state',
  '$rootScope',
  'constants',
  'SimulationService',
  'ModelsService',
  'StatesService',
  'DecisionsService',
  'WidgetsService',
  'TemplatesService',
  function (
    $scope,
    $state,
    $rootScope,
    constants,
    SimulationService,
    ModelsService,
    StatesService,
    DecisionsService,
    WidgetsService,
    TemplatesService
  ) {
    'use strict';

    $scope.constants = null;

    $scope.form = {
      template: null,
      schema: null,
      form: null,
      model: {}
    };

    $scope.state = $state;

    $scope.states = {
      list: [],
      current: null
    };

    $scope.templates = [
      {
        key: 'state.learningOutcomes',
        value: 'Learning Outcomes'
      },
      {
        key: 'state.choiceDecision',
        value: 'Choice Decision'
      },
      {
        key: 'state.contentView',
        value: 'Content View'
      }
    ];

    /**
     * Moves the services to a new state
     *
     * @param {string} stateId - state identifer to transition to
     */
    $scope.goToState = function goToState(stateId) {
      StatesService.goToState(stateId);
    };


    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants.constants;

      TemplatesService.setTemplates(constants.constants);
    }

    /**
     * Method sets state data from Model
     *
     * @private
     */
    function defineStateList() {
      $scope.states.list = _.filter($scope.simulation.current.relatives, function (obj) {
        return _.includes(obj.classes, 'states');
      });

      $scope.states.list = StatesService.getFromList($scope.states.list);
    }

    /**
     * Method sets widget data from Model
     *
     * @private
     */
    function defineWidgetList() {
      var tmpList = [];
      var unorderedWidgets;

      if ($scope.states.current) {
        unorderedWidgets = WidgetsService
            .getWidgetsFromRelatives($scope.states.current.relatives);

        if ($scope.states.current) {
          $scope.widgets.all = WidgetsService
            .getWidgetsFromRelatives($scope.simulation.current.relatives);
        }
        _.forEach($scope.widgets.all, function (all) {
          var found;

          found = _.find(unorderedWidgets, { id: all.id });


          if (found) {
            tmpList.push(found);
            all.active = true;
          } else {
            all.active = false;
          }
        });

        $scope.widgets.list = tmpList;


        if (
          $state.params.widgetId
          && $state.params.widgetId !== 'events'
          && $state.params.widgetId !== 'sbar'
        ) {
          $scope.widgets.current = _.find($scope.widgets.all, { id: $state.params.widgetId });
          $scope.widgets.current = ModelsService.find('widgets', 'id', $scope.widgets.current.id);
        }

        $rootScope.widgetLock = false;
      }
    }

    /**
     * Defines the current state
     */
    function defineCurrentState() {
      if ($state.params.stateId && !SimulationService.checkForDisabled($state.params.stateId)) {
        $scope.states.current = StatesService.get($state.params.stateId);
        $scope.states.formatted = StatesService.get($state.params.stateId, true);
        $scope.states.formatted.content.decisions = DecisionsService
          .get($scope.states.current.content.decisions[0], true);
        SimulationService.setCurrentProgress($state.params.stateId);
        // $scope.states.current.content.rules = RulesService
        //   .getFromList($scope.states.current.content.rules);
        // $scope.states.current.content.decisions = DecisionsService
        //   .getFromList($scope.states.current.content.decisions);
        // $scope.states.current.content.widgets = WidgetsService
        //   .getFromList($scope.states.current.content.widgets);

        // var schema = ModelsService.find('schemas', 'label', $scope.states.current.content.type);
        // $scope.form.schema = schema.content.schema;
        // $scope.form.form = schema.content.form;
        // $scope.form.model = StatesService.populateModel(
        //   TemplatesService.getModel($scope.states.current.content.type),
        //   $scope.states.current
        // );
      } else {
        $scope.states.next = SimulationService.progress.current;
        $scope.states.current = null;
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      if ($scope.simulation) {
        defineConstants();
        defineCurrentState();
        defineStateList();
        defineWidgetList();
      }
    }
    initialize();
  }
]);
